import { ElementProps } from "../../../types/common";

export const WhatsAppIcon = (props: ElementProps) => (
  <svg
    width={12}
    height={12}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.001.167a5.833 5.833 0 1 1-2.934 10.876l-2.897.79.789-2.898A5.833 5.833 0 0 1 6.001.166ZM4.013 3.258l-.116.005a.56.56 0 0 0-.217.058.755.755 0 0 0-.172.133c-.07.066-.11.123-.152.179-.216.28-.332.625-.33.979 0 .286.076.564.192.824.239.526.631 1.083 1.15 1.6.124.124.247.249.379.365.643.566 1.41.975 2.24 1.193l.33.05c.109.007.217-.001.325-.007a1.16 1.16 0 0 0 .486-.134c.077-.04.151-.083.224-.129 0 0 .025-.016.072-.052.08-.059.128-.1.193-.168a.67.67 0 0 0 .122-.176c.046-.095.091-.277.11-.428.014-.115.01-.178.008-.218-.002-.062-.054-.127-.11-.154l-.34-.152s-.508-.221-.818-.363a.29.29 0 0 0-.103-.024.281.281 0 0 0-.22.074c-.003 0-.042.033-.464.544a.204.204 0 0 1-.214.075.832.832 0 0 1-.112-.038L6.33 7.23a3.514 3.514 0 0 1-.919-.585c-.073-.064-.141-.134-.211-.202-.23-.22-.43-.468-.595-.74l-.035-.055a.538.538 0 0 1-.06-.12c-.021-.085.036-.154.036-.154s.142-.155.208-.24c.064-.081.118-.16.153-.217.07-.11.09-.225.055-.313a48.561 48.561 0 0 0-.507-1.19c-.034-.078-.136-.134-.229-.146l-.094-.009a1.974 1.974 0 0 0-.236.003l.118-.005Z"
      fill="#22282B"
    />
  </svg>
);
